module.exports = __webpack_public_path__ + "static/edmond.bf0a2acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/edmond.png
// module id = 571
// module chunks = 263791100135453